<template>
  <div>
    <v-layout row wrap mt-4>
      <v-flex xs12 sm4 md1 text-xs-right class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="100" imaSrc="design/gray-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm6 md8 class="animated fadeInUp">
        <ui-title-one titleAccess="Para determinar el valor de su patrimonio" titleLevel="h1">
          <template slot="partOne">Para determinar el<br></template>
          <template slot="partTwo">valor de su </template>
          <template slot="partThree"> patrimonio</template>
        </ui-title-one>
        <p class="davi-curs">debe tener en cuenta los siguientes componentes:</p>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Determinar su patrimonio'" videoEmbed="ADMINISTRACIONDINERO46DeterminarPatrimonio.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm8 class="animated fadeIn">
        <p>
          <strong>Haga clic sobre cada definición:</strong>
        </p>
      </v-flex>
    </v-layout>

    <!-- Componente contenidos de botones slide -->
    <ui-botsacronimos :ordered="true" :bold="true" :bots="bots" nombreLista="Componentes">
      <div v-for="(item, index) in bots" :key="'content'+index" :slot="'cont-'+index" class="animated fadeInRight">
        <p v-html="item.cont"></p>
      </div>
    </ui-botsacronimos>
    <!-- Fin de componente -->
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      contenido: 0,
      bots: [
        {
          name: "El activo ",
          nameDesing: "<span class='font-red'>El</span> <span class='font-normal'>activo</span>",
          cont: `Abarca <strong>todo el efectivo</strong>, es decir el dinero de las cuentas corrientes,
          de ahorro, los certificados de depósito o inversiones financieras, las inversiones en bienes
          raíces (casa y cualquier otra propiedad), vehículos, y posesiones de valor, como arte,
          antigüedades o joyas.`,
          visto: false
        },
        {
          name: "El pasivo ",
          nameDesing:"<span class='font-red'>El</span class='font-red'> <span class='font-normal'>pasivo</span>",
          cont: `Incluye <strong>todas las deudas</strong> a corto plazo como tarjetas de crédito y deudas a largo plazo como el pago de créditos de vivienda, entre otros.`,
          visto: false
        }
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-46.vue?4b961074